export default __webpack_public_path__ + "static/media/outfit_youngstylish.a10e6f44.png";